import ms from 'ms'

//  Monday, October 31, 2022 12:00:00 PM GMT
//  Monday, October 31, 2022 20:00:00 PM GMT +08:00
export const SALE_BEGIN_TIME = process.env.NEXT_PUBLIC_SALE_BEGIN_TIME
  ? parseInt(process.env.NEXT_PUBLIC_SALE_BEGIN_TIME, 10)
  : 1667217600

export const WL_BEGIN_TIME = SALE_BEGIN_TIME + ms('2d') / 1000

export const WL_ENDED_TIME = WL_BEGIN_TIME + ms('4d') / 1000

export const PREORDER_BEGIN_TIME = SALE_BEGIN_TIME + ms('4d') / 1000

export const LAST_DAY_BEGIN_TIME = SALE_BEGIN_TIME + ms('13d') / 1000

export const SALE_ENDED_TIME = process.env.NEXT_PUBLIC_SALE_ENDED_TIME
  ? parseInt(process.env.NEXT_PUBLIC_SALE_ENDED_TIME, 10)
  : SALE_BEGIN_TIME + ms('14d') / 1000

export const INCUBATION__START_TIME = SALE_ENDED_TIME + ms('14d') / 1000

export enum SalePhases {
  PREPARE     = 'Prepare',
  RELEASE     = 'release',
  WHITELISTED = 'Whitelisted',
  PREORDER    = 'PreOrder',
  LAST_DAY    = 'LastDay',
  CLOSED      = 'closed',
}